import { router } from "@inertiajs/react";
import type { PagyMetadata } from "@/types";

interface PaginationControlsProps {
  pagy: PagyMetadata;
}

export const PaginationControls = ({ pagy }: PaginationControlsProps) => {
  const navigate = (page: number) => {
    router.get(
      window.location.pathname,
      { page },
      { preserveState: true, preserveScroll: false },
    );
  };

  return (
    <div className="flex items-center justify-between px-6 py-4 border-t border-border">
      <div className="text-sm text-muted-foreground">
        Showing {pagy.from} to {pagy.to} of {pagy.count} transactions
      </div>

      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() => navigate(pagy.previous!)}
          disabled={!pagy.previous}
          className="px-4 py-2 text-sm border border-border rounded-md bg-card hover:bg-muted disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          Previous
        </button>

        <span className="px-4 py-2 text-sm text-muted-foreground">
          Page {pagy.page} of {pagy.last}
        </span>

        <button
          type="button"
          onClick={() => navigate(pagy.next!)}
          disabled={!pagy.next}
          className="px-4 py-2 text-sm border border-border rounded-md bg-card hover:bg-muted disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          Next
        </button>
      </div>
    </div>
  );
};
